export class LlmInfoShort {
  public name: string;
  public displayName: string;
  public description?: string;
  public speed: number;
  public intelligence: number;
  public isPublic: boolean;

  constructor(data: any) {
    this.name = data.name;
    this.displayName = data.displayName;
    this.description = data.description;
    this.speed = data.speed;
    this.intelligence = data.intelligence;
    this.isPublic = data.isPublic;
  }
}
